import {
  MrrArrCategories,
  MrrArrBrekadownData,
  ConversionRateBrekadownData,
  ConversionRateCategories,
  ViolationsBreakdownCategories,
  ViolationBrekadownData,
  SrrArrCategories,
  SrrArrBrekadownData,
} from "./ChartData";

export const MrrArrProps = {
  categories: MrrArrCategories,
  data: MrrArrBrekadownData,
  colors: ["#2F3A79", "#000525"],
  useGradient: false,
  tooltipFormatter: (val) => `₹${val}`,
};
export const retentionAndChurnProps = {
  categories: MrrArrCategories,
  data: MrrArrBrekadownData,
  colors: ["#2F3A79", "#000525"],
  yTitle: "",
  useGradient: false,
  tooltipFormatter: (val) => `${val}%`,
};
export const SrrArrProps = {
  categories: SrrArrCategories,
  data: SrrArrBrekadownData,
  colors: ["#2F3A79", "#000525"],
  yTitle: "",
  useGradient: true,
  tooltipFormatter: (val) => `${val} units`,
};

export const ConversionRateProps = {
  categories: ConversionRateCategories,
  data: ConversionRateBrekadownData,
  colors: ["#2F3A79", "#000525"],
  yTitle: "",
  useGradient: false,
  tooltipFormatter: (val) => `${val} Users`,
};

export const CltvProps = {
  categories: ViolationsBreakdownCategories,
  data: ViolationBrekadownData,
  colors: ["#2F3A79", "#000525"],
  yTitle: "Avg Lifetime Revenue(₹)",
  useGradient: false,
  tooltipFormatter: (val) => `${val} units`,
};
